import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import {
    SpsSummaryListColComponent,
    SpsSummaryListRowComponent,
    SpsSummaryListExpansionComponent,
} from "../components/index";

@NgModule({
    imports: [CommonModule],
    declarations: [
        SpsSummaryListColComponent,
        SpsSummaryListRowComponent,
        SpsSummaryListExpansionComponent
    ],
    exports: [
        SpsSummaryListColComponent,
        SpsSummaryListRowComponent,
        SpsSummaryListExpansionComponent
    ]
})
export class SpsSummaryListViewModule {}
